
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.667 0H2v1.333H.667V0zm0 3.333H2v1.334H.667V3.333zm0 3.334H2V8H.667V6.667zm10.666-5.334V0H3.35v1.333h7.984zm-8 2h8v1.334h-8V3.333zm0 3.334h8V8h-8V6.667z","fill":"#fff"}})])
          )
        }
      }
    